import text from "components/shared/css/text.module.scss";
import LogoIcon2 from "static/svgs/logo2";
import LoginSlider from "../Login/LoginSlider";
import ResetPasswordForm from "./ResetPasswordForm";
import styles from "./forgotpass.module.scss";
const ResetPasswordContainer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <LogoIcon2 />
        <div className={styles.loginBox}>
          <ResetPasswordForm />
        </div>
      </div>
      <div className={styles.right}>
        <div>
          <LoginSlider />
        </div>
        <p className={`${text.normal2} ${text.textWhite} ${text.textCenter}`}>
          © 2022 QuantLayer. All rights reserved
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordContainer;
